import React, { useState, useEffect } from 'react';

const APP_PASSWORD = 'Peer+'; // Change this to your desired password

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if already authenticated
    const auth = localStorage.getItem('peer_app_auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === APP_PASSWORD) {
      localStorage.setItem('peer_app_auth', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Wrong password, babe. Try again 💜');
      setPassword('');
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[rgb(var(--background))]">
        <div className="text-2xl text-[rgb(var(--primary))]">Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[rgb(var(--background))] px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">🔐</div>
          <h1 className="text-3xl font-bold text-gradient mb-2">PeeR+</h1>
          <p className="text-[rgb(var(--text-secondary))]">
            This app is currently in beta 💜
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 rounded-2xl bg-[rgb(var(--surface))] border border-white/10 text-[rgb(var(--text-primary))] placeholder:text-[rgb(var(--text-secondary))]/50 focus:outline-none focus:border-[rgb(var(--primary))]/50 text-center text-lg"
              autoFocus
            />
          </div>

          {error && (
            <p className="text-center text-sm text-[rgb(var(--danger))]">{error}</p>
          )}

          <button
            type="submit"
            className="w-full py-3 rounded-2xl bg-gradient-to-r from-[rgb(var(--primary))] to-[rgb(var(--secondary))] text-white font-semibold hover:opacity-90 transition-opacity"
          >
            Enter App
          </button>
        </form>

        <p className="text-center text-xs text-[rgb(var(--text-secondary))]/50 mt-6">
          Contact the PSP team for access
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
